import React from "react";
import { ApolloProvider } from "@apollo/client/react";

import { useAuth } from "#app/lib/auth-context";
import { createApolloClient } from "./apollo-client";

let _workspaceId: string | null = null;

export function setActiveWorkspaceId(id: string | null) {
  _workspaceId = id;
}

export function getActiveWorkspaceId(): string | null {
  return _workspaceId;
}

export function DataProvider({ children }: { children: React.ReactNode }) {
  const { getAccessToken, signOut } = useAuth();

  const client = React.useMemo(
    () =>
      createApolloClient({
        getAccessToken,
        getWorkspaceId: () => _workspaceId,
        onUnauthenticated: signOut,
      }),
    [getAccessToken, signOut],
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
